/* eslint-disable quote-props */
const esMessages = {
  'title': 'Catálogo Oficial del Futurecom 2017',
  'shortTitle': 'Catálogo Futurecom',
  // Navigation
  'generalProgramming': 'Programación General',
  'sponsors': 'Patrocinadores',
  'personalities': 'Personalidades',
  'roundTables': 'Paneles',
  'agenda': 'Agenda',
  'keynotes': 'Oradores',
  'mediaPartners': 'Media Partners',
  'floorplan': 'Plano',
  'exhibitors': 'Expositores',
  'testimonials': 'Declaraciones',
  'organization': 'Organización',
  'futurecomWebsite': 'Página web del Futurecom',
  'seeMore': 'Más detalles',
  'back': 'Regresar',
  // Titles
  'coordinador': '{gender, select, female {Coordinadora} other {Coordinador}}',
  'invitedPanelists': 'Panelistas invitados',
  'participationAtTheCongress': 'Participación en el Congreso:',
  'description': 'Descripción: ',
  'scope': 'Coberetura:',
  'language': 'Idioma de Publicación:',
  'themes': 'Temas en destaque:',
  'locale': 'Localización:',
  'mainExecutive': 'Principal Ejecutivo: ',
  'marketingExecutive': 'Responsable de Marketing: ',
  'others': 'Otros:',
  'roundTableDetailsRoom': '{icon} Auditorio {room}',
  // Paragraphs
  'agendaText': 'See the full Futurecom 2017\'s Agenda at:',
  'floorplanText': 'See the full Futurecom 2017\'s map at:',
  'organizationText':
    `
      Futurecom es parte de Global Exhibitions Division de Informa PLC.
    `,
  // Date and time
  'roundTableDateTime': '{icon} {date, date, short}, de las {starting, time, short} a las {ending, time, short}',
  'roundTableDetailsDateTime': '{icon} {date, date}, de las {starting, time, short} a las {ending, time, short}',
  'roundTableRoom': '{icon} AUDITORIO {room}',
  'time': 'de las {starting, time, short} a las {ending, time, short}',
  // Other
  'booth': 'stand {booth}',
  'search': 'Buscar...',
  // Messages
  'noData': 'No se encontraron datos.',
};
/* eslint-enable */

export default esMessages;



/** WEBPACK FOOTER **
 ** ./src/intl/esMessages.js
 **/